export const SAVE = 'stepSnowSports.SAVE';
export const VALUE_CHANGED = 'stepSnowSports.VALUE_CHANGED';
export const LOAD = 'stepSnowSports.VALUE_LOAD';
export const NEXT = 'stepSnowSports.NEXT';
export const RESET = 'stepSnowSports.RESET';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSnowSports/constants.js